import React, {useEffect, useMemo, useRef} from "react";
import { withStyles } from "@material-ui/styles";
import { connect } from "react-redux";
import Typography from "@material-ui/core/Typography";
import Grid from "@material-ui/core/Grid";
import InfoField from "../../../../../../ui/InfoDrawer/components/InfoField";
import Tooltip from "@material-ui/core/Tooltip";
import IconButton from "@material-ui/core/IconButton";
import ClearIcon from "@material-ui/icons/Clear";
import UploadDropzone from "../../../../../../ui/FileIUpload/UploadDropzone";
import AttachmentCard from "../../../../../../ui/AttachmentCard";
import {
  updateCertificate,
  updateProgramFile,
  updateProgramLogo
} from "../../../../../../ManageOOP/Resources/OpMod/MyOPMod/store/send";
import {
  deleteCertificate,
  deleteProgramFile,
  deleteProgramLogo
} from "../../../../../../ManageOOP/Resources/OpMod/MyOPMod/store/deleteactions";

const styles = () => ({
  root: {
    maxWidth: 774,
    minWidth: 400,
    marginLeft: 8,
    marginRight: 8,
    "& .MuiGrid-spacing-xs-4 > .MuiGrid-item": {
      paddingTop: 4,
      paddingBottom: 5
    }
  },
  container: {
    width: "100%",
    marginTop: "16px"
  },
  heading: {
    fontSize: 14,
    lineHeight: "18px",
    display: "flex",
    alignItems: "center",
    color: "#000000",
    margin: "8px 0"
  },
  mainGrid:{
    marginTop: 8
  },
  dropzoneWraper: {
    display: "flex",
    justifyContent: "flex-start",
    alignItems: "flex-start"
  },
  dropZoneButtonArea: {
    width: 75,
    height: 35,
    zIndex: 1000,
    position: "absolute",
    display: "flex",
    justifyContent: "flex-start",
    alignItems: "flex-start",
  },
  fileInput: {
    display: 'none'
  },
  iconButton: {
    padding: 0,
    "&:hover": {
      backgroundColor: "transparent"
    }
  }
});

const ProgramFiles = ({classes, programId, disabled,
                        certificateFile,
                        programFile,
                        programLogo,
                        updateProgramFile,
                        updateProgramLogo,
                        updateCertificate,
                        deleteProgramLogo,
                        deleteProgramFile,
                        deleteCertificate}) => {

  const UploadProgramLogo = files => {
    if (programId && programId > -1 && files.length > 0) {
      updateProgramLogo(programId, files[0]);
    }
  };

  const UploadProgramFile = files => {
    if (programId && programId > -1 && files.length > 0) {
      updateProgramFile(programId, files[0]);
    }
  }

  const UploadCertificateFile = files => {
    if (programId && programId > -1 && files.length > 0) {
      updateCertificate(programId, files[0]);
    }
  }

  return(
    <div className={classes.root}>
      <Typography className={classes.heading}>Загруженные файлы</Typography>
      <Grid container spacing={1} className={classes.mainGrid}>
        <Grid item xs={12} md={6}>
          <div>
            <InfoField name="Файл рабочей программы" />
            <div>
              {programFile ? (
                <AttachmentCard
                  id={programFile.fileId}
                  mimeType={programFile.mimeType}
                  fileName={programFile.fileName}
                  fileSize={programFile.size}
                  fileLink={programFile.fileId}
                  download
                  removeDocument={() => deleteProgramFile(programId)}
                />
              ) : (
                <UploadDropzone
                  onDrop={program => {
                    UploadProgramFile(program);
                  }}
                  accept={[".pdf"]}
                  maxSize={2000000}
                />
              )}
            </div>
          </div>
        </Grid>
        <Grid item xs={12} md={6}>
          <div>
            <InfoField name="Файл сертификата" />
            <div>
              {certificateFile ? (
                <AttachmentCard
                  id={certificateFile.fileId}
                  mimeType={certificateFile.mimeType}
                  fileName={certificateFile.fileName}
                  fileSize={certificateFile.size}
                  fileLink={certificateFile.fileId}
                  download
                  removeDocument={() => deleteCertificate(programId)}
                />
              ) : (
                <UploadDropzone
                  onDrop={program => {
                    UploadCertificateFile(program);
                  }}
                  accept={[".pdf"]}
                  maxSize={2000000}
                />
              )}
            </div>
          </div>
        </Grid>
        <Grid item xs={12} md={6}>
          <div>
            <InfoField name="Изображение карточки" />
            <div className={classes.dropzoneWraper}>
              <div className={classes.dropZoneButtonArea}>
                <Tooltip title="Удалить" placement="top">
                  <IconButton
                    classes={{ root: classes.iconButton }}
                    onClick={() => deleteProgramLogo(programId)}
                  >
                    <ClearIcon />
                  </IconButton>
                </Tooltip>
              </div>
              <UploadDropzone
                type="card"
                fileId={programLogo}
                accept={[".jpg", ".jpeg", ".png"]}
                onDrop={image => {
                  UploadProgramLogo(image);
                }}
              />
            </div>
          </div>
        </Grid>
      </Grid>
    </div>
  );
}

const mapStateToProps = state => ({});

const mapDispatchToProps = dispatch => ({
  updateProgramLogo: (id, file) => dispatch(updateProgramLogo(id, file)),
  updateProgramFile: (id, file) => dispatch(updateProgramFile(id, file)),
  updateCertificate: (id, file) => dispatch(updateCertificate(id, file)),
  deleteProgramLogo: (id) => dispatch(deleteProgramLogo(id)),
  deleteProgramFile: (id) => dispatch(deleteProgramFile(id)),
  deleteCertificate: (id) => dispatch(deleteCertificate(id))
});

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(withStyles(styles)(ProgramFiles));
